"use client";

import { X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/scott/ui/elements/button/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from "@/scott/ui/elements/dialog/dialog";
import type { ProductDetailSizeChart } from "../product-detail-page.adapter";

interface ProductSizeChartProps {
  sizeChart: ProductDetailSizeChart;
  microcopies: {
    close: string;
    linkLabel: string;
  };
}

export function ProductSizeChart(props: Readonly<ProductSizeChartProps>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        className="mt-3 h-auto justify-start p-0 text-left text-sm underline"
        onClick={() => setIsOpen(true)}
        type="button"
        unstyled
        variant="link"
      >
        {props.microcopies.linkLabel}
      </Button>

      <Dialog onOpenChange={setIsOpen} open={isOpen}>
        <DialogContent
          className="max-h-[90svh] max-w-[65%] overflow-hidden p-0"
          hideCloseButton
        >
          <DialogTitle className="sr-only">{props.sizeChart.title}</DialogTitle>

          <div className="relative bg-white shadow-2xl">
            <DialogClose className="absolute top-4 right-4 z-10 cursor-pointer bg-transparent opacity-70 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none">
              <X className="h-6 w-6" />
              <span className="sr-only">{props.microcopies.close}</span>
            </DialogClose>

            <img
              alt={props.sizeChart.title}
              className="block max-h-[90svh] w-full object-contain"
              src={props.sizeChart.url}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
